import { render, staticRenderFns } from "./MessageBar.vue?vue&type=template&id=0200b011"
import script from "./MessageBar.vue?vue&type=script&lang=ts"
export * from "./MessageBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports